export enum EmailConfigActionTypes {
	FETCH_ALL_EMAIL_CC_CONFIG_REQUEST = 'emailConfig/FETCH_ALL_EMAIL_CC_CONFIG_REQUEST',
	FETCH_ALL_EMAIL_CC_CONFIG_SUCCESS = 'emailConfig/FETCH_ALL_EMAIL_CC_CONFIG_SUCCESS',
	FETCH_ALL_EMAIL_CC_CONFIG_FAILURE = 'emailConfig/FETCH_ALL_EMAIL_CC_CONFIG_FAILURE',

	GET_EMAIL_CC_CONFIG_BY_NAME_REQUEST = 'emailConfig/GET_EMAIL_CC_CONFIG_BY_NAME_REQUEST',
	GET_EMAIL_CC_CONFIG_BY_NAME_SUCCESS = 'emailConfig/GET_EMAIL_CC_CONFIG_BY_NAME_SUCCESS',
	GET_EMAIL_CC_CONFIG_BY_NAME_FAILURE = 'emailConfig/GET_EMAIL_CC_CONFIG_BY_NAME_FAILURE',

	UPSERT_EMAIL_CC_CONFIG_REQUEST = 'emailConfig/UPSERT_EMAIL_CC_CONFIG_REQUEST',
	UPSERT_EMAIL_CC_CONFIG_SUCCESS = 'emailConfig/UPSERT_EMAIL_CC_CONFIG_SUCCESS',
	UPSERT_EMAIL_CC_CONFIG_FAILURE = 'emailConfig/UPSERT_EMAIL_CC_CONFIG_FAILURE',

	FETCH_EMAIL_AUTOCOMPLETE_REQUEST = 'emailConfig/FETCH_EMAIL_AUTOCOMPLETE_REQUEST',
	FETCH_EMAIL_AUTOCOMPLETE_SUCCESS = 'emailConfig/FETCH_EMAIL_AUTOCOMPLETE_SUCCESS',
	FETCH_EMAIL_AUTOCOMPLETE_FAILURE = 'emailConfig/FETCH_EMAIL_AUTOCOMPLETE_FAILURE',

	CLEAR_EMAIL_SUGGESTIONS = 'emailConfig/CLEAR_EMAIL_SUGGESTIONS',
	RESET_EMAIL_CONFIG_DETAIL = 'emailConfig/RESET_EMAIL_CONFIG_DETAIL'
}
